



















import Vue from 'vue'
import { MessageChannel } from '../../../base/store/state.interface'
import { WidgetSettingsCheckbox, WidgetSettingType } from '../../widgets/base/widget/WidgetInterface'
import SettingsPanelCustomCheckbox from '../SettingsPanelCustomCheckbox.vue'
import { SettingsPanelCustomCustomMixin } from './SettingsPanelCustomCustomMixin'

export default Vue.extend({
  mixins: [SettingsPanelCustomCustomMixin],
  components: {
    SettingsPanelCustomCheckbox
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    const config = {
      channelMode: 0,
      unreadMessagesOnly: false,
      channelIds: [] as any[]
    }

    this.syncConfigProperties(config, this.data)

    return {
      config: config,
      availableChannels: this.getAvailableChannels(config.channelIds),
      numSelectedChannels: config.channelIds.length
    }
  },
  computed: {
    cboxSettingsUnreadMessagesOnly(): WidgetSettingsCheckbox {
      const config = this.config
      const isDisabled = (config.channelMode === '1') && (this.numSelectedChannels < 2)
      return {
        type: WidgetSettingType.checkbox,
        title: 'Nur Kanäle mit ungelesenen Nachrichten',
        checked: config.unreadMessagesOnly && !isDisabled,
        disabled: isDisabled
      }
    }
  },
  methods: {
    getAvailableChannels(selectedChannels: number[] = []): WidgetSettingsCheckbox[] {
      const channels = Object.values(this.$store.state.message_channel.items)
      const result: WidgetSettingsCheckbox[] = []

      channels.forEach((channel: MessageChannel) => {
        const channelId = channel.id
        result.push({ type: WidgetSettingType.checkbox, title: channel.title, checked: selectedChannels.indexOf(channelId) > -1, value: channelId })
      })

      return result
    }
  },
  updated() {
    const channels = this.availableChannels
    const config = this.config

    config.channelIds = []

    channels.forEach(channel => {
      if (!channel.checked) {
        return
      }
      config.channelIds.push(channel.value)
    })

    this.numSelectedChannels = this.config.channelIds.length

    if ((config.channelMode === '1') && (this.numSelectedChannels < 2)) {
      this.config.unreadMessagesOnly = false
    }

    this.$emit('update', this.config)
  }
})
